import React, { useState } from 'react';
import { Search, Paperclip, Send, MoreVertical, MapPin } from 'lucide-react';
import { mockConversations, formatNaira } from '../../data/mockData';
interface MessagingViewProps {
  type: 'buyer' | 'seller';
}
export const MessagingView = ({
  type
}: MessagingViewProps) => {
  const [activeConvId, setActiveConvId] = useState(mockConversations[0].id);
  const [messageInput, setMessageInput] = useState('');
  const activeConv = mockConversations.find(c => c.id === activeConvId) || mockConversations[0];
  return <div className="bg-white rounded-2xl shadow-sm border border-neutral-200 h-[calc(100vh-12rem)] flex overflow-hidden animate-in fade-in" data-id="element-251">
      {/* Sidebar */}
      <div className="w-1/3 border-r border-neutral-200 flex flex-col bg-neutral-50 shrink-0" data-id="element-252">
        <div className="p-4 border-b border-neutral-200 bg-white" data-id="element-253">
          <h2 className="text-lg font-serif font-bold text-primary-900 mb-4" data-id="element-254">
            {type === 'buyer' ? 'Messages' : 'Inquiries'}
          </h2>
          <div className="relative" data-id="element-255">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-dark" size={18} data-id="element-256" />
            <input type="text" placeholder="Search conversations..." className="w-full pl-10 pr-4 py-2 rounded-lg border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 outline-none text-sm" data-id="element-257" />
          </div>
        </div>

        <div className="flex-grow overflow-y-auto custom-scrollbar" data-id="element-258">
          {mockConversations.map(conv => <div key={conv.id} onClick={() => setActiveConvId(conv.id)} className={`p-4 border-b border-neutral-100 cursor-pointer transition-colors flex gap-3 ${activeConvId === conv.id ? 'bg-primary-50 border-l-4 border-l-primary-900' : 'hover:bg-neutral-100 border-l-4 border-l-transparent'}`} data-id="element-259">
              <div className="w-10 h-10 rounded-full bg-primary-900 text-white flex items-center justify-center font-bold shrink-0" data-id="element-260">
                {conv.participant.avatar}
              </div>
              <div className="flex-grow min-w-0" data-id="element-261">
                <div className="flex justify-between items-start mb-1" data-id="element-262">
                  <h4 className="font-bold text-sm text-text truncate" data-id="element-263">
                    {conv.participant.name}
                  </h4>
                  <span className="text-[10px] text-text-light whitespace-nowrap ml-2" data-id="element-264">
                    {conv.time}
                  </span>
                </div>
                <p className="text-xs text-text-light truncate" data-id="element-265">
                  {conv.lastMessage}
                </p>
              </div>
              {conv.unread > 0 && <div className="w-5 h-5 rounded-full bg-secondary text-white text-[10px] font-bold flex items-center justify-center shrink-0 mt-1" data-id="element-266">
                  {conv.unread}
                </div>}
            </div>)}
        </div>
      </div>

      {/* Main Chat Area */}
      <div className="flex-grow flex flex-col bg-white" data-id="element-267">
        {/* Chat Header */}
        <div className="p-4 border-b border-neutral-200 flex justify-between items-center bg-white" data-id="element-268">
          <div className="flex items-center gap-3" data-id="element-269">
            <div className="w-10 h-10 rounded-full bg-primary-900 text-white flex items-center justify-center font-bold" data-id="element-270">
              {activeConv.participant.avatar}
            </div>
            <div data-id="element-271">
              <h3 className="font-bold text-text" data-id="element-272">
                {activeConv.participant.name}
              </h3>
              <p className="text-xs text-text-light" data-id="element-273">
                {activeConv.participant.type}
              </p>
            </div>
          </div>
          <button className="p-2 text-text-light hover:text-text rounded-lg hover:bg-neutral-100 transition-colors" data-id="element-274">
            <MoreVertical size={20} data-id="element-275" />
          </button>
        </div>

        {/* Property Reference Card */}
        <div className="p-4 bg-neutral-50 border-b border-neutral-200" data-id="element-276">
          <div className="bg-white p-3 rounded-xl border border-neutral-200 flex gap-4 items-center shadow-sm" data-id="element-277">
            <img src={activeConv.property.images[0]} alt="" className="w-16 h-16 rounded-lg object-cover" data-id="element-278" />
            <div className="flex-grow" data-id="element-279">
              <h4 className="font-bold text-sm text-primary-900 line-clamp-1" data-id="element-280">
                {activeConv.property.title}
              </h4>
              <div className="flex items-center gap-2 text-xs text-text-light mt-1" data-id="element-281">
                <MapPin size={12} data-id="element-282" /> {activeConv.property.district} •{' '}
                {formatNaira(activeConv.property.price)}
              </div>
            </div>
            <button className="px-4 py-2 bg-primary-50 text-primary-900 text-xs font-bold rounded-lg hover:bg-primary-100 transition-colors whitespace-nowrap" data-id="element-283">
              View Listing
            </button>
          </div>
        </div>

        {/* Messages */}
        <div className="flex-grow overflow-y-auto p-6 space-y-6 custom-scrollbar bg-neutral-50/50" data-id="element-284">
          {activeConv.messages.map(msg => {
          const isMe = msg.sender === 'me';
          return <div key={msg.id} className={`flex flex-col ${isMe ? 'items-end' : 'items-start'}`} data-id="element-285">
                <div className={`max-w-[70%] p-3 rounded-2xl ${isMe ? 'bg-primary-900 text-white rounded-tr-sm' : 'bg-white border border-neutral-200 text-text rounded-tl-sm shadow-sm'}`} data-id="element-286">
                  <p className="text-sm" data-id="element-287">{msg.text}</p>
                </div>
                <span className="text-[10px] text-text-light mt-1 px-1" data-id="element-288">
                  {msg.time}
                </span>
              </div>;
        })}
        </div>

        {/* Input Area */}
        <div className="p-4 border-t border-neutral-200 bg-white" data-id="element-289">
          <div className="flex items-end gap-2" data-id="element-290">
            <button className="p-3 text-neutral-dark hover:text-primary-900 hover:bg-primary-50 rounded-xl transition-colors shrink-0" data-id="element-291">
              <Paperclip size={20} data-id="element-292" />
            </button>
            <div className="flex-grow relative" data-id="element-293">
              <textarea rows={1} placeholder="Type a message..." value={messageInput} onChange={e => setMessageInput(e.target.value)} className="w-full pl-4 pr-12 py-3 rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 outline-none text-sm resize-none custom-scrollbar max-h-32" style={{
              minHeight: '46px'
            }} data-id="element-294" />
            </div>
            <button className="p-3 bg-primary-900 text-white hover:bg-primary-800 rounded-xl transition-colors shadow-sm shrink-0" data-id="element-295">
              <Send size={20} data-id="element-296" />
            </button>
          </div>
        </div>
      </div>
    </div>;
};